import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from 'shared/translate';
import { AutenticacaoService } from './services/autenticacao.service';
import { CookieService } from 'ngx-cookie-service';
import { HttpParams } from '@angular/common/http';
import { PlataformaService } from './services/plataforma.service';
import { enumTransacao } from 'shared/domains/enumtransacao.enum';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(private router: Router, public _translate: TranslateService, public srvAutenticacao: AutenticacaoService, private cookieService: CookieService,
    private srvPlataforma: PlataformaService) {
    var valorCookie=  cookieService.get("IdiomaCookie");
    if (!valorCookie)
    this._translate.use("pt-BR");
    else
    this._translate.use(valorCookie);
  }

  public ngOnInit() {
    
    var AcaoRedirecionamento: string = this.RetornarValorParametro("scope");
    var CodigoRedirecionamento: string = this.RetornarValorParametro("intent_id");
    if (AcaoRedirecionamento && CodigoRedirecionamento)
    {
      this.srvPlataforma.CodigoAcao = CodigoRedirecionamento;
      if ("payment" == AcaoRedirecionamento.toLowerCase()
      || "openid" == AcaoRedirecionamento.toLowerCase())
        this.srvPlataforma.TelaInicial = enumTransacao.ConsentimentoPagamentoOpenBanking;
        this.srvPlataforma.PaginaRedirecionamento = this.RetornarValorParametro("redirect_uri");
    }

    if (this.srvAutenticacao.PossuiToken()) {
      this.srvAutenticacao.ValidarToken().subscribe(v => {
        
        if (v) {
          this.srvAutenticacao.CarregarDadoToken().subscribe(d => {
            if (d ) {
              this.srvAutenticacao.PreencherAcesso(d)
              //this.router.navigate(["home"]);
            }
          });
        }
        else {
          this.srvAutenticacao.LogOut();
          this.router.navigate(["login"]);
        }

      });


    }
    else
      this.router.navigate(["login"]);

  }

  RetornarValorParametro( paramName:string ): string {
    const url = window.location.href;
    let paramValue;
    if (url.includes('?')) {
      const httpParams = new HttpParams({ fromString: url.split('?')[1] });
      paramValue = httpParams.get(paramName);
    }
    return paramValue;
  }
}